import {
  SocialInstagramIcon,
  SocialPinterestIcon,
  SocialTiktokIcon,
  SocialTwitterIcon,
  SocialYoutubeIcon,
} from '@contra/icons/icons';

const linksAndNames = {
  careers: {
    link: 'https://contra.com/careers',
    name: 'Careers',
  },
  commissionFree: {
    link: 'https://contra.com/commission-free',
    name: 'Commission-Free',
  },
  contraForHiring: {
    link: 'https://contra.com/how-it-works/clients',
    name: 'Contra For Hiring',
  },
  contraForIndependents: {
    link: 'https://contra.com/how-it-works/independents',
    name: 'Contra For Independents',
  },
  design: {
    link: 'https://contra.com/discover/independents?category=Design',
    name: 'Design',
  },
  engineering: {
    link: 'https://contra.com/discover/independents?category=Engineering',
    name: 'Engineering',
  },
  faq: {
    link: 'https://contra.com/faq',
    name: 'FAQ',
  },
  freelanceIndustryReport: {
    link: 'https://contra.com/freelance-industry-report-2021',
    name: 'Freelance Industry Report',
  },
  hire: {
    link: 'https://contra.com/jobs/new',
    name: 'Hire',
  },
  latestVideo: {
    link: 'https://contra.com',
    name: 'Latest Video',
  },
  marketing: {
    link: 'https://contra.com/discover/independents?category=Marketing',
    name: 'Marketing',
  },
  mission: {
    link: 'https://contra.com/mission',
    name: 'Mission',
  },
  musicAndAudio: {
    link: 'https://contra.com/discover/independents?category=Music%20%26%20Audio',
    name: 'Music & Audio',
  },
  newsroom: {
    link: 'https://contra.com/TheContrarian/news',
    name: 'Newsroom',
  },
  socialMedia: {
    link: 'https://contra.com/discover/independents?category=Social%20Media',
    name: 'Social Media',
  },
  successStories: {
    link: 'https://contra.com/reviews',
    name: 'Success Stories',
  },
  support: {
    link: 'mailto:hello@contra.com',
    name: 'Support',
  },
  tipsAndGuides: {
    link: 'https://contra.com/blog',
    name: 'Tips & Guides',
  },
  videoAndAnimation: {
    link: 'https://contra.com/discover/independents?category=Video%20%26%20Animation',
    name: 'Video & Animation',
  },
  writing: {
    link: 'https://contra.com/discover/independents?category=Writing',
    name: 'Writing',
  },
} as const;

/**
 * @package
 */
export type IconLink = { icon: JSX.Element; label: string; link: string };
/**
 * @package
 */
export type SectionColumn = Section | Section[];

/**
 * @package
 */
export type TextLink = { link: string; name: string };

type Section = ({ links: IconLink[] } | { links: TextLink[] }) & {
  title: string;
};

/**
 * @package
 */
export const sections: SectionColumn[] = [
  {
    links: [
      linksAndNames.contraForIndependents,
      linksAndNames.contraForHiring,
      linksAndNames.successStories,
      linksAndNames.commissionFree,
    ],
    title: 'How it Works',
  },
  {
    links: [
      linksAndNames.mission,
      linksAndNames.careers,
      linksAndNames.newsroom,
    ],
    title: 'Company',
  },
  {
    links: [
      linksAndNames.faq,
      linksAndNames.tipsAndGuides,
      linksAndNames.hire,
      linksAndNames.support,
    ],
    title: 'Resources',
  },
  {
    links: [
      linksAndNames.design,
      linksAndNames.engineering,
      linksAndNames.marketing,
      linksAndNames.musicAndAudio,
      linksAndNames.socialMedia,
      linksAndNames.videoAndAnimation,
      linksAndNames.writing,
    ],
    title: 'Dіscover Freelancers',
  },
  [
    {
      links: [linksAndNames.freelanceIndustryReport],
      title: 'Drops',
    },
    {
      links: [
        {
          icon: <SocialTiktokIcon size={24} />,
          label: 'TikTok',
          link: 'https://tiktok.com/@contrahq',
        },
        {
          icon: <SocialTwitterIcon size={24} />,
          label: 'Twitter',
          link: 'https://twitter.com/contra',
        },
        {
          icon: <SocialInstagramIcon size={24} />,
          label: 'Instagram',
          link: 'https://instagram.com/contra',
        },
        {
          icon: <SocialYoutubeIcon size={24} />,
          label: 'Youtube',
          link: 'https://www.youtube.com/@contra4046',
        },
        {
          icon: <SocialPinterestIcon size={24} />,
          label: 'Pinterest',
          link: 'https://www.pinterest.com/contrahq',
        },
      ],
      title: 'Social',
    },
  ],
];
